export const formatPhoneNumber = (value: string) => {
  const digits = Array.from(value).filter(char => /\d/.test(char));

  return [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 10)]
    .filter(chunk => chunk.length > 0)
    .map(chunk => chunk.join(''))
    .join('-');
};
